import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Parlour Party</h1>
            </header>
            <div className="content">
                <p>Our board game service is designed around your needs, to bring value to your guests and increase your profits
                    by offering an exciting new ammenity to your business.
                </p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Learn More</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
